<script>
  import Page from 'page'
  export let memberData
  import { api } from '../../store'
  let localapi
  api.subscribe((value) => {
    localapi = value
  })

  let fullName = memberData.fullName
  let age = memberData.age
  let skillsIntrest = memberData.skillsIntrest
  let mainid = memberData.mainid
  let id = memberData.id

  function validateForm() {
    let allValue = {
      fullName,
      age,
      skillsIntrest,
      mainid,
      id,
    }

    let error = ''

    for (const [key, value] of Object.entries(allValue)) {
      if (value === undefined) {
        error += `${key}\n`
        console.log(key)
      }
    }

    error == ''
      ? senddata(allValue)
      : alert(`Please fill the folowing fields \n${error}`)
  }

  let senddata = async (param) => {
    let loginDatum = JSON.parse(localStorage.getItem('loginData'))
    let data = new FormData()
    data.append('fullName', param.fullName)
    data.append('age', param.age)
    data.append('skillsIntrest', param.skillsIntrest)
    data.append('mainid', loginDatum.email)

    let xhttp = new XMLHttpRequest()

    // xhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded')
    xhttp.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        // Typical action to be performed when the document is ready:
        let result = JSON.parse(xhttp.responseText)
        console.log(result)

        if (result.error == false) {
          console.log('Kid ok')
        } else {
          // Page.redirect('/')
        }
      }
    }
    xhttp.open('POST', `${localapi}?url=updateMemberkid`, true)
    xhttp.setRequestHeader('Authorization', `Bearer ${loginDatum.token}`)
    xhttp.send(data)
  }

  function del(e) {
    let loginDatum = JSON.parse(localStorage.getItem('loginData'))
    let data = new FormData()
    data.append('id', e.target.value)
    data.append('mainid', loginDatum.email)

    let xhttp = new XMLHttpRequest()

    // xhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded')
    xhttp.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        // Typical action to be performed when the document is ready:
        let result = JSON.parse(xhttp.responseText)
        console.log(result)

        if (result.error == false) {
          window.location.reload()
          console.log('Kid ok')
        } else {
          // Page.redirect('/')
        }
      }
    }
    xhttp.open('POST', `${localapi}?url=removeMemberkid`, true)
    xhttp.setRequestHeader('Authorization', `Bearer ${loginDatum.token}`)
    xhttp.send(data)
  }
</script>

<div class="login">
  <form on:submit|preventDefault="{validateForm}">
    <div>
      <h2 class="text-center">Update Members kid</h2>
    </div>

    <div class="row">
      <div class="form-group  col-6 mb-3 mt-3">
        <label for="exampleInputEmail1">First Name</label>
        <input
          required
          type="text"
          class="form-control"
          bind:value="{fullName}" />
      </div>

      <div class="form-group  col-6 mb-3 mt-3">
        <label for="exampleInputEmail1">Age</label>
        <input required type="number" class="form-control" bind:value="{age}" />
      </div>

      <div class="form-group  col-6 mb-3 mt-3">
        <label for="exampleInputEmail1">Skills / Interest</label>
        <input
          required
          type="text"
          class="form-control"
          bind:value="{skillsIntrest}" />
      </div>

      <div class="form-group col-6 mb-3 mt-3">
        <label for="exampleInputEmail1">MainId</label>
        <input
          required
          type="text"
          disabled
          class="form-control"
          bind:value="{mainid}" />
      </div>
    </div>

    <button type="submit" class="btn btn-primary">Submit</button>
  </form>
  <!-- <button on:click="{del}" value="{id}" class="btn btn-danger"> Delete </button> -->
</div>

<style lang="scss">
  .login {
    padding: 10px;
    min-height: 40vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: 5vh;
    margin-bottom: 10vh;
    border: 3px solid rgb(71, 71, 71) !important;
    margin-left: 10px;
    margin-right: 10px;

    form {
      width: 350px;
      .btn {
        width: 100%;
        margin-top: 10px;
      }
    }
    .btn {
      width: 100%;
      margin-top: 10px;
    }
  }
</style>
